import { AllDrugsWrapper } from "../style";
import Table from "@/common/components/Table";
import useQuery from "@/hooks/useQuery";
import { INVENTORY_DATA_URL } from "@/common/constants";
import { DRFCrumb } from "@/common/components/drf-breadcrumb";
import { Pagination } from "@/common/components/pagination";
import { useState } from "react";
import Tab2 from "@/common/components/Tab/Tab2";
import {
  restockingLogTableHead,
  salesLogTableHead,
  stockLevelInventoryTableHead,
} from "../data";

const AllPharmacyDrugs = () => {
  const [_, setStockLevelPerPage] = useState(10);
  const [currentTab, setCurrentTab] = useState("Stock Inventory");
  const { data: inventory_products, loading: headOfHospitalAllDrugLoading } =
    useQuery(INVENTORY_DATA_URL + `?page=1`);

  const tabs = [
    {
      title: "Stock Inventory",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={stockLevelInventoryTableHead}
            tableKeys={[]}
            tableData={[]}
            tableTitle="Stock Level Report"
            loading={headOfHospitalAllDrugLoading}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={inventory_products?.total_pages}
            onNextPage={(event: any) => setStockLevelPerPage(event.selected)}
            onPerPageChange={(event: any) =>
              setStockLevelPerPage(event?.target?.value)
            }
          />
        </div>
      ),
    },
    {
      title: "Restocking Log",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={restockingLogTableHead}
            tableKeys={[]}
            tableData={[]}
            tableTitle="Restocking Log Report"
            loading={headOfHospitalAllDrugLoading}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={inventory_products?.total_pages}
            onNextPage={(event: any) => setStockLevelPerPage(event.selected)}
            onPerPageChange={(event: any) =>
              setStockLevelPerPage(event?.target?.value)
            }
          />
        </div>
      ),
    },
    {
      title: "Sales Log",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={salesLogTableHead}
            tableKeys={[]}
            tableData={[]}
            tableTitle="Sales log Report"
            loading={headOfHospitalAllDrugLoading}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={inventory_products?.total_pages}
            onNextPage={(event: any) => setStockLevelPerPage(event.selected)}
            onPerPageChange={(event: any) =>
              setStockLevelPerPage(event?.target?.value)
            }
          />
        </div>
      ),
    },
  ];
  return (
    <AllDrugsWrapper>
      <DRFCrumb
        currentPage="All Drug Inventory"
        previousPage="Dashboard"
        previousPageLink="/dashboard/pharmacy-head/inventory"
      />
      <div className="cta-wrapper">
        <div className="cta-title">
          <h1>ALL DRUG INVENTORY</h1>
          <p>Manage your pharmaceutical inventory</p>
        </div>
      </div>
      <Tab2
        onTabClick={(tab: string) => setCurrentTab(tab)}
        currentTab={currentTab}
        tabs={tabs}
      />
    </AllDrugsWrapper>
  );
};

export default AllPharmacyDrugs;
